export default "__VITE_ASSET__DhRM7Qwc__"